import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaArrowLeft } from 'react-icons/fa';
import { useTasks } from '../context/TaskContext';
import TaskListModern from '../components/TaskListModern';
import TaskModal from '../components/TaskModal';
import taskService from '../services/taskService';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';

const TaskListScreen = () => {
  const { tasks, deleteTask, fetchTasks } = useTasks();
  const { toast } = useToast();
  const navigate = useNavigate();
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  
  const handleToggleStatus = async (task) => {
    try {
      await taskService.toggleTaskCompletion(task.id);
      toast({
        title: `Task ${!task.is_completed ? 'completed' : 're-opened'}`,
        variant: "default",
      });
      setRefreshKey(prev => prev + 1);
    } catch (error) {
      toast({
        title: 'Failed to update task status',
        variant: "destructive",
      });
    }
  };
  
  const handleDeleteTask = async (id) => {
    if (window.confirm('Are you sure you want to delete this task?')) {
      try {
        await deleteTask(id);
        toast({
          title: 'Task deleted successfully',
          variant: "default",
        });
        setRefreshKey(prev => prev + 1);
      } catch (error) {
        toast({
          title: 'Failed to delete task',
          variant: "destructive",
        });
      }
    }
  };

  const handleEditTask = (task) => {
    setCurrentTask(task);
    setIsModalOpen(true);
  };
  
  const handleAddTask = () => {
    setCurrentTask(null);
    setIsModalOpen(true);
  };
  
  const handleSaveTask = () => {
    toast({
      title: `Task ${currentTask ? 'updated' : 'added'} successfully`,
      variant: "default",
    });
    setRefreshKey(prev => prev + 1);
  };
  
  return (
    <div className="max-w-[1200px] mx-auto p-4 md:p-8">
      <div className="flex justify-between items-center mb-8">
        <div className="flex items-center gap-4">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center justify-center p-2 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-50 hover:border-gray-400 hover:text-gray-700 transition-all duration-200"
            title="Back to Home"
          >
            <FaArrowLeft className="h-4 w-4" />
          </button>
          <h1 className="text-2xl font-bold">Tasks</h1>
        </div>
        <Button onClick={handleAddTask} className="flex items-center gap-2">
          <FaPlus className="h-4 w-4" />
          Add Task
        </Button>
      </div>
      
      <TaskListModern 
        refreshTrigger={refreshKey}
        onTaskToggle={handleToggleStatus}
        onTaskEdit={handleEditTask}
        onTaskDelete={handleDeleteTask}
      />
      
      <TaskModal 
        isOpen={isModalOpen}
        task={currentTask}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveTask}
      />
    </div>
  );
};

export default TaskListScreen; 